import { en } from './en.js'

export const id = structuredClone(en)

id.visualGameAdmin.conversionFunnelDevices = {'label': 'Jenis perangkat sumber', 'all': 'Semua', 'desktop': 'Komputer', 'mobile': 'Ponsel', 'tablet': 'Tablet'}

id.visualGameAdmin.pageFunnel = {'button': 'Lihat corong halaman', 'title': 'Corong halaman', 'home': 'Beranda', 'auth': 'Masuk atau daftar', 'game': 'Halaman permainan', 'note': 'Sesi yang melewati langkah berurutan sesuai waktu dan perangkat. Termasuk dialog masuk PC. Data historis tanpa pelacakan tidak dapat dipulihkan.', 'loading': 'Memuat…', 'error': 'Gagal memuat', 'sessions': 'sesi'}

id.visualGameAdmin.pageFunnel.viewUsers = 'Lihat pengguna'
id.visualGameAdmin.pageFunnel.peopleUnit = 'pengguna'
id.visualGameAdmin.pageFunnel.timesUnit = 'kali'

id.visualGameAdmin.pageFunnel.userFilter_all = 'Corong: daftar atau masuk'

id.visualGameAdmin.pageFunnel.userFilter_sign_up = 'Corong: terdaftar dalam periode'

id.visualGameAdmin.pageFunnel.userFilter_login = 'Corong: masuk dalam periode'

id.visualGameAdmin.usageActivity = {
  "title": "Penggunaan situs · Aktivitas",
  "button": "Lihat detail",
  "all": "Semua aktivitas",
  "search": "Cari pengguna, game atau ID",
  "user": "Pengguna",
  "game": "Game",
  "kind": "Aktivitas",
  "status": "Status",
  "time": "Waktu",
  "detail": "Lihat catatan",
  "empty": "Tidak ada catatan",
  "loading": "Memuat…",
  "error": "Gagal memuat",
  "note": "Input menggunakan peristiwa pihak pertama dan dapat berbeda dari GA4. Teks dan sesi yang tidak tercatat tidak disimpulkan.",
  "limit": "Menampilkan 1000 catatan terbaru. Persempit rentang tanggal untuk melihat lainnya.",
  "text_input": "Input teks",
  "voice_input": "Input suara",
  "slice_video": "Pembuatan klip",
  "global_video": "Pembuatan video lengkap",
  "free_game": "Pembuatan game gratis"
}

Object.assign(id.visualGameAdmin.usageActivity, {
  "status_queued": "Antrean",
  "status_running": "Berjalan",
  "status_ready": "Selesai",
  "status_failed": "Gagal",
  "status_submitting": "Mengirim",
  "status_submitted": "Terkirim",
  "status_ok": "Berhasil",
  "status_error": "Gagal",
  "status_generating": "Membuat",
  "status_generation_failed": "Pembuatan gagal",
  "status_pending_review": "Menunggu tinjauan",
  "status_review_rejected": "Ditolak",
  "status_published": "Diterbitkan",
  "status_archived": "Diarsipkan"
})

id.visualGameAdmin.usageActivity.records = 'catatan'

id.visualGameAdmin.paypointActivity = {
  "title": "Titik pembayaran · Detail",
  "all": "Semua",
  "game": "Halaman",
  "kind": "Konteks pembayaran",
  "status": "Pemicu",
  "note": "Catatan pihak pertama dapat berbeda dari GA4. Membuka dialog video tidak berarti kredit kurang. Catatan lama tidak menyimpan saldo, biaya atau ID sesi.",
  "billing_paypoint_gameplay": "Gameplay",
  "billing_paypoint_ending_video": "Video akhir",
  "billing_paypoint_story_video": "Video cerita",
  "status_insufficient_balance": "Kredit permainan kurang",
  "status_dialog_open": "Dialog pembuatan dibuka"
}

id.visualGameAdmin.paypointActivity.search = 'Cari pengguna, halaman atau ID'

id.visualGameAdmin.orderDrilldown = {
  "button": "Lihat pesanan",
  "dateField": "Dasar waktu",
  "created_at": "Waktu dibuat",
  "paid_at": "Waktu dibayar"
}

Object.assign(id.visualGameAdmin.orderDrilldown, {
  "since": "Waktu mulai",
  "until": "Waktu akhir"
})

id.visualGameAdmin.orderDrilldown.updated_at = 'Waktu pembaruan status'

id.visualGameAdmin.trafficBaseline = {
  "confirmed": "Pertambahan terkonfirmasi",
  "first": "Tayangan pengambilan pertama (tanpa acuan historis)",
  "missing": "Data awal tidak ada; pertambahan tidak lengkap",
  "note": "Video yang diterbitkan dalam rentang tanggal dimulai dari nol dan tayangan pengambilan pertama dihitung dalam pertumbuhan. Video lebih lama atau tanpa tanggal terbit dan tanpa catatan sebelum rentang tetap ditampilkan terpisah. Tanggal pengambilan bukan tanggal terbit.",
  "observed": "Tanggal pengamatan pertama",
  "filter": "Data awal tidak ada",
  "unchanged": "Tidak bertambah (data awal lengkap)",
  "later": "Pertambahan setelah pengamatan pertama"
}

id.visualGameAdmin.funnelAuth = {
  registration: 'Pendaftaran situs',
  login: 'Login situs',
  new_users: 'Login pengguna baru',
  existing_users: 'Login pengguna lama',
  note: 'Pengguna baru mendaftar dalam periode yang dipilih; pengguna lama sebelum periode. Login mencakup login otomatis setelah pendaftaran berhasil. Jumlah pengguna dideduplikasi; jumlah login mencakup login otomatis dan login sukses berikutnya. Pendaftaran dan login tumpang tindih dan tidak boleh dijumlahkan.',
  user_type: 'Jenis pengguna',
  registered_at: 'Waktu pendaftaran',
  new_type: 'Pengguna baru',
  existing_type: 'Pengguna lama',
  auto_login: 'Login otomatis setelah pendaftaran'
}

id.visualGameAdmin.funnelPeriods = {
  yesterday: 'Kemarin',
  last_three_days: '3 hari terakhir'
}

id.visualGameAdmin.videoExport = {
  button: 'Ekspor daftar saat ini CSV',
  published_sort: 'Menurut waktu publikasi',
  published_label: 'Dipublikasikan',
  unknown: 'Tidak tercatat'
}

id.visualGameAdmin.storyFilmPromptReview = {
      title: 'Tinjauan prompt drama',
      subtitle: 'Tinjauan konten prompt final per-shot dan parameter permintaan. Menyetujui konten bukan berarti memanggil H3 atau film siap tayang.',
      gateNotice: 'Persetujuan hanya mencakup prompt dan rencana. Panggilan H3 vendor tetap di balik gerbang anggaran/batas terpisah; saat ini belum disetujui dan tidak ada tombol panggilan.',
      loading: 'Memuat…',
      empty: 'Belum ada paket',
      filters: {
      status: 'Status tinjauan',
      all: 'Semua',
      owner: 'Pemain (owner)',
      ownerPlaceholder: 'user id',
      run: 'Run simpanan',
      runPlaceholder: 'run_id',
      branch: 'Cabang',
      branchPlaceholder: 'branch_id',
      season: 'Musim',
      seasonPlaceholder: 'season_id',
      episode: 'Episode',
      episodePlaceholder: 'episode_id',
      planDigest: 'Versi rencana',
      planDigestPlaceholder: 'plan_digest',
      version: 'Versi paket',
      versionPlaceholder: 'nomor versi',
    },
      actions: {
      search: 'Cari',
      clear: 'Hapus filter',
      view: 'Lihat',
      more: 'Muat lagi',
      approve: 'Setujui konten',
      reject: 'Kembalikan untuk revisi',
      rejectPlaceholder: 'Alasan (wajib)',
      regenerate: 'Versi baru',
      simulatedNotification: 'Lihat notifikasi simulasi',
    },
      validation: {
      limit: '{count}/{max} karakter (tanpa spasi di awal dan akhir)',
      required: 'Isi alasan sebelum mengembalikan paket.',
      too_long: 'Alasan maksimal {max} karakter. Persingkat sebelum mengirim; paket belum dikembalikan.',
      invalid_body: 'Alasan tidak diterima. Periksa masukan: {message}',
    },
      notice: {
      approve: 'Konten disetujui; tanpa panggilan H3, tanpa biaya.',
      reject: 'Dikembalikan dengan alasan tercatat.',
      regenerate: 'Versi baru dibuat; tinjau lagi.',
    },
      columns: {
      episode: 'Episode',
      version: 'Versi',
      status: 'Status',
      shots: 'Shot',
      duration: 'Durasi',
      digest: 'Ringkasan paket',
      createdAt: 'Dibuat',
    },
      status: {
      draft: 'Menunggu tinjauan',
      in_review: 'Sedang ditinjau',
      approved: 'Disetujui',
      rejected: 'Dikembalikan',
      superseded: 'Digantikan',
    },
      detail: {
      title: 'Paket #{id} · v{version}',
      owner: 'Pemain',
      film: 'Karya',
      season: 'Musim',
      episode: 'Episode',
      run: 'Run',
      branch: 'Cabang',
      range: 'Rentang turn',
      sourceVersion: 'Versi sumber',
      snapshot: 'Snapshot',
      planDigest: 'Ringkasan rencana',
      packDigest: 'Ringkasan paket',
      planVersion: 'Versi paket/rencana',
      cutPolicy: 'Versi kebijakan potong',
      costModel: 'Versi model biaya',
      gate: 'Gerbang',
      gateValue: 'Anggaran={budget} · model biaya={cost} · poin perkiraan={points} · dukungan prompt negatif={negative}',
      provider: 'Vendor',
      providerValue: '{provider} / {model} · {size} · steps={steps} · turbo={turbo} · antrean={priority} · {shots} shot',
      shotsTitle: 'Paket permintaan per-shot',
      chars: '{count} karakter',
      sendable: 'Dapat dikirim',
      notSendable: 'Tidak dapat dikirim',
      blocked: 'Alasan terblokir',
      promptTitle: 'Prompt positif final',
      requestTitle: 'Parameter permintaan (hanya bidang terverifikasi)',
      evidenceTitle: 'Bukti sumber (terlihat pemain)',
      anchorsTitle: 'Anchor karakter/lokasi',
      speakers: 'Karakter',
      locations: 'Lokasi',
      references: 'Aset referensi',
      negativeTitle: 'Prompt negatif (tinjauan konten; bidang vendor belum terverifikasi)',
      negativeGate: 'Prompt negatif tidak termasuk permintaan yang dapat dikirim: adaptor H3 saat ini belum memverifikasi bidang itu.',
      episodeSummary: 'Shot {shots} · durasi {duration}ms · frame {frames} · kuantisasi {frameMs}ms · batas total {caps}ms',
      quoteSummary: 'Snapshot kutipan: {status} · poin perkiraan {points} · koefisien {ppm}ppm · {currency}',
      cost: 'Biaya perkiraan: {points}',
      costUnapproved: 'belum disetujui',
    },
      events: {
      title: 'Jejak tinjauan',
    },
    }

id.visualGameAdmin.storyFilmPromptReview.simulatedPage = {
      title: 'Pratinjau notifikasi simulasi',
      subtitle: 'Tinjauan dengan muatan simulasi tetap; tanpa baca/tulis DB, email, atau biaya.',
      isolation: 'Halaman ini terisolasi dari ready outbox nyata, media, status gratis pertama, dan SMTP; tanpa pemutaran atau refund nyata.',
      back: 'Kembali ke tinjauan prompt',
    }
id.visualGameAdmin.storyFilmPromptReview.detail.trim = 'rencana {plan}ms / hasil {gen}ms (potong sisanya)'

id.visualGameAdmin.storyFilmPromptReview.detail.providerValue = '{provider} / {model} · {size} · {aspect} · seluler {fit} · kemampuan {capability} · steps={steps} · turbo={turbo} · antrean={priority} · {shots} shot'

id.visualGameAdmin.storyFilmPromptReview.detail.episodeSummary = 'Shot {shots} · rencana {duration}ms · frame rencana {frames} · kuantisasi {frameMs}ms · batas total {caps}ms · H3 {h3fps}fps'
id.visualGameAdmin.storyFilmPromptReview.detail.selection = 'Kontrak seleksi A'

id.visualGameAdmin.storyFilmPromptReview.detail.selectionValue = '{status} · {version} · {units} unit · dihilangkan {omitted} karakter · {digest}'
id.visualGameAdmin.storyFilmPromptReview.detail.selectionArc = 'Bukti penutup settlement={settlement} · ending={ending} · opening={opening} · climax={climax} · resolution={resolution}'
id.visualGameAdmin.storyFilmPromptReview.detail.generation = 'Potongan final {final}ms / generasi {gen}ms / cap {cap}ms'

id.visualGameAdmin.storyFilmPromptReview.detail.capExceeded = 'Generasi melebihi cap {over}ms; tidak dapat dikirim'

id.visualGameAdmin.storyFilmPromptReview.detail.durationSplit = 'Final {final}ms / generasi {gen}ms / cap {cap}ms / shot melebihi {exceeded}'
